export default __webpack_public_path__ + "static/media/central_ministry.3272d3c8.webp";